<div fxFlexFill fxLayout="column" fxLayoutAlign="start stretch">
  <h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px">
    <div fxFlex>Manage Button Templates</div>
    <button mat-icon-button [mat-dialog-close]="false" class="button-40">
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <mat-dialog-content class="mat-typography" fxFlex>
    <app-device-button-templates-list
      [availableExpansionDevices]="availableExpansionDevices"
    ></app-device-button-templates-list>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      mat-flat-button
      color="primary"
      [disabled]="!!buttonTemplateList().templateUsed()"
      (click)="onAddTemplate()"
    >
      + Add Template
    </button>
  </mat-dialog-actions>
</div>
